<template>
  <header 
    @keydown.esc="fecharMenus"
    :class="[
      'tw-border-b tw-px-2 md:tw-px-4 tw-py-1 md:tw-py-3 tw-h-14 md:tw-h-auto tw-fixed md:tw-sticky tw-top-0 tw-left-0 tw-right-0 tw-z-[1100] tw-w-full',
      theme === 'dark' ? 'tw-bg-[#0f1114] tw-border-[#1e2024]' : 'tw-bg-[#e9eef6] tw-border-gray-200 tw-shadow-sm'
    ]"
  >
    <nav class="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-w-full tw-h-full">
      
      <!-- Left section: Menu + Title -->
      <div class="tw-flex tw-items-center tw-gap-2 tw-min-w-0">
        <button v-if="!isActive('UnidadesPage') && !isActive('ConsultaAvancadaPage') && !isActive('ParametrosCheckoutPage')"
          @click="toggleSidebar" 
          :class="[
            'tw-p-2 tw-rounded-md', 
            theme === 'dark' ? 'hover:tw-bg-gray-800' : 'hover:tw-bg-gray-100'
          ]"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" 
            :stroke="theme === 'dark' ? 'white' : '#374151'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect width="18" height="18" x="3" y="3" rx="2" ry="2"/><line x1="9" x2="9" y1="3" y2="21"/>
          </svg>
        </button>

        <div v-if="!isActive('UnidadesPage') && !isActive('ConsultaAvancadaPage') && !isActive('ParametrosCheckoutPage')" :class="['tw-h-8 tw-w-[1px]', theme === 'dark' ? 'tw-bg-gray-700' : 'tw-bg-gray-200']" class="tw-hidden xs:tw-block tw-mx-2"></div>

        <div class="tw-flex tw-flex-col tw-justify-center tw-min-w-0">
          <h1 :class="['tw-font-bold tw-leading-tight tw-tracking-tight tw-line-clamp-2', theme === 'dark' ? 'tw-text-white' : 'tw-text-gray-800', 'tw-text-xs sm:tw-text-sm md:tw-text-base']">
            {{ vue_app_name }} <span class="tw-hidden sm:tw-inline tw-text-gray-500 tw-font-medium tw-ml-1 tw-text-[10px] xs:tw-text-xs">v{{ version }}</span>
          </h1>
        </div>
      </div>

      <!-- Right section: Actions -->
      <div class="tw-flex tw-items-center tw-gap-1 md:tw-gap-2 tw-flex-shrink-0">
        <!-- Theme toggle -->
        <button 
          @click="toggleTheme" 
          aria-label="Alternar tema"
          class="tw-p-2 tw-rounded-full tw-relative tw-w-10 tw-h-10 tw-hidden md:tw-flex tw-items-center tw-justify-center tw-overflow-hidden"
          :class="theme === 'dark' ? 'hover:tw-bg-[#1e2227]' : 'hover:tw-bg-gray-100'"
          style="will-change: transform; transform: translateZ(0);"
        >
          <transition name="theme-fade">
            <svg 
              v-if="theme === 'dark'"
              key="sun"
              xmlns="http://www.w3.org/2000/svg" 
              class="tw-w-6 tw-h-6 tw-absolute tw-stroke-white" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke-width="2"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 3v2.25m0 13.5V21m8.966-8.966h-2.25M5.25 12H3m14.593-7.343l-1.591 1.591M6.75 17.25l-1.591 1.591M17.25 17.25l1.591 1.591M6.75 6.75L5.159 5.159M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>

            <svg 
              v-else
              key="moon"
              xmlns="http://www.w3.org/2000/svg" 
              class="tw-w-6 tw-h-6 tw-absolute tw-stroke-gray-800" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke-width="2"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z" />
            </svg>
          </transition>
        </button>      
        <div v-if="menuUnidade || menuUser" @click="fecharMenus" class="tw-fixed tw-inset-0 tw-z-40"></div>

        <div class="tw-relative tw-z-50">
          <button 
            @click="menuUnidade = !menuUnidade; menuUser = false"
            :aria-expanded="menuUnidade"
            :class="[
              'tw-flex tw-items-center tw-gap-2 tw-h-9 md:tw-h-10 tw-px-2 md:tw-px-3 tw-rounded-xl tw-text-xs md:tw-text-[13px] tw-font-semibold tw-transition-colors focus:tw-outline-none',
              theme === 'dark' ? 'tw-text-gray-200 hover:tw-bg-[#1e2227]' : 'tw-text-gray-800 hover:tw-bg-gray-100',
              menuUnidade ? (theme === 'dark' ? 'tw-bg-[#1e2227]' : 'tw-bg-gray-100') : ''
            ]"
          >
            <span class="tw-hidden sm:tw-inline"><i class="fa-solid fa-building"></i></span>
            <span>Unidades</span>
            <i class="fa-solid fa-chevron-down tw-text-[9px]" :class="{'tw-rotate-180': menuUnidade}"></i>
          </button>
          
          <div v-if="menuUnidade" :class="[menuPanelClass, 'tw-w-64']">
            <div class="tw-p-2">
              <div class="tw-relative">
                <i class="fa-solid fa-magnifying-glass tw-absolute tw-left-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-gray-400 tw-text-xs"></i>
                <input
                  v-model="buscaUnidade"
                  type="text"
                  placeholder="Buscar unidade..."
                  :class="[
                    'tw-w-full tw-pl-8 tw-pr-3 tw-py-2 tw-text-xs tw-rounded-lg focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-[#33b35a]/20',
                    theme === 'dark' ? 'tw-bg-[#151719] tw-text-gray-200' : 'tw-bg-gray-100 tw-text-gray-800'
                  ]"
                />
              </div>
            </div>

            <div class="tw-px-2 tw-pb-2">
              <router-link to="/v2/unidades/" @click="fecharMenus" :class="menuItemClass()">
                <i class="fa-solid fa-house tw-w-4 tw-text-center"></i> Minhas Unidades
              </router-link>
            </div>

            <div class="tw-max-h-[30vh] tw-overflow-y-auto custom-scrollbar tw-px-2 tw-pb-2">
              <router-link
                v-for="unidade in unidadesFiltradas"
                :key="unidade.id"
                :to="'/v2/unidades/' + unidade.id"
                @click="fecharMenus"
                :class="menuItemClass(isUnidadeAtual(unidade))"
              >
                <span class="tw-truncate tw-flex-1">{{ unidade.nome }}</span>
                <i v-if="isUnidadeAtual(unidade)" class="fa-solid fa-check tw-text-[10px] tw-shrink-0"></i>
              </router-link>

              <div
                v-if="unidadesFiltradas.length === 0"
                class="tw-px-3 tw-py-4 tw-text-center tw-text-xs tw-text-gray-500"
              >
                Nenhuma unidade encontrada.
              </div>
            </div>
          </div>
        </div>

        <!-- User menu -->
        <div class="tw-relative tw-z-50">
          <button 
            @click="menuUser = !menuUser; menuUnidade = false"
            :aria-expanded="menuUser"
            aria-label="Menu do usuário"
            class="tw-flex tw-items-center tw-rounded-full tw-transition-shadow focus:tw-outline-none"
            :class="menuUser ? 'tw-ring-2 tw-ring-[#33b35a]/30' : ''"
          >
            <div class="tw-w-8 tw-h-8 tw-bg-[#33b35a] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-xs tw-font-bold tw-text-white">
              {{ user ? user.nome.charAt(0).toUpperCase() : 'U' }}
            </div>
          </button>

          <div v-if="menuUser" :class="[menuPanelClass, 'tw-w-60']">
            <div v-if="user" class="tw-flex tw-items-center tw-gap-3 tw-px-4 tw-pt-4 tw-pb-2">
              <div class="tw-w-9 tw-h-9 tw-bg-[#33b35a] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-bold tw-text-white tw-shrink-0">
                {{ user.nome.charAt(0).toUpperCase() }}
              </div>
              <div class="tw-min-w-0">
                <p :class="['tw-text-[13px] tw-font-semibold tw-truncate', theme === 'dark' ? 'tw-text-gray-200' : 'tw-text-gray-800']">{{ user.nome }}</p>
                <p class="tw-text-xs tw-text-gray-500 tw-truncate">{{ user.email }}</p>
              </div>
            </div>

            <div class="tw-p-2 tw-space-y-0.5">
              <router-link to="/minha-conta" @click="fecharMenus" :class="menuItemClass()">
                <i class="fa-solid fa-user tw-w-4 tw-text-center"></i> Minha Conta
              </router-link>
              <button @click="toggleTheme" :class="[menuItemClass(), 'md:tw-hidden']">
                <i class="fa-solid tw-w-4 tw-text-center" :class="theme === 'dark' ? 'fa-sun' : 'fa-moon'"></i>
                {{ theme === 'dark' ? 'Tema claro' : 'Tema escuro' }}
              </button>
              <button
                @click="authLogout"
                :class="[
                  'tw-w-full tw-flex tw-items-center tw-gap-3 tw-px-3 tw-py-2.5 tw-rounded-lg tw-text-[13px] tw-font-semibold tw-text-left tw-text-red-500 tw-transition-colors',
                  theme === 'dark' ? 'hover:tw-bg-red-500/10' : 'hover:tw-bg-red-50'
                ]"
              >
                <i class="fa-solid fa-right-from-bracket tw-w-4 tw-text-center"></i> Sair
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapActions, mapGetters, useStore } from 'vuex';
import { watch, ref, computed } from 'vue';

export default {
    setup () {
        const store = useStore();
        const vue_app_name = process.env.VUE_APP_NAME;
        const version = process.env.VUE_APP_VERSION;
        const menuUnidade = ref(false);
        const menuUser = ref(false);

        const unidadeAtual = ref({});
        const unidades = computed(() => store.state.unidades.unidades || []);
        const buscaUnidade = ref('');

        watch(() => store.state.unidade.unidade, (newUnidade) => {
            unidadeAtual.value = newUnidade || {};
        }, { immediate: true });

        return {
            vue_app_name,
            version,
            unidades,
            unidadeAtual,
            menuUnidade,
            menuUser,
            buscaUnidade
        }
    },
    computed: {
        ...mapGetters('auth', ['getUser']),
        ...mapGetters('ui', ['theme']),
        user() { return this.getUser; },
        menuPanelClass() {
          return [
            'tw-absolute tw-right-0 tw-mt-2 tw-rounded-xl tw-shadow-xl tw-overflow-hidden',
            this.theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-white'
          ];
        },
        unidadesFiltradas() {
          const busca = this.buscaUnidade.toLowerCase().trim();

          if (!busca) {
            return this.unidades;
          }

          return this.unidades.filter(unidade =>
            unidade.nome.toLowerCase().includes(busca)
          );
        }
    },
    methods: {
        ...mapActions('auth', ['logout']),
        ...mapActions('ui', ['toggleSidebar', 'toggleTheme']),
        async authLogout() {
            try {
                await this.logout();
                this.$router.push('/v2/login');
            } catch (error) {
                console.error('Erro ao fazer logout:', error);
            }
        },
        fecharMenus() {
            this.menuUnidade = false;
            this.menuUser = false;
            this.buscaUnidade = '';
        },
        isUnidadeAtual(unidade) {
            return String(unidade.id) === String(this.$route.params.unidade);
        },
        menuItemClass(selecionado = false) {
            return [
              'tw-w-full tw-flex tw-items-center tw-gap-3 tw-px-3 tw-py-2.5 tw-rounded-lg tw-text-[13px] tw-font-semibold tw-text-left tw-transition-colors',
              selecionado
                ? 'tw-bg-[#33b35a]/15 tw-text-[#2b9e4f]'
                : (this.theme === 'dark' ? 'tw-text-gray-200 hover:tw-bg-[#262a30]' : 'tw-text-gray-800 hover:tw-bg-gray-100')
            ];
        },
        isActive(route) {
            return this.$route.name === route || this.$route.path.includes(route);
        }
    }
}
</script>

<style scoped>.theme-fade-enter-active,
.theme-fade-leave-active {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.theme-fade-enter-from {
  transform: rotate(-90deg) scale(0);
  opacity: 0;
}

.theme-fade-leave-to {
  transform: rotate(90deg) scale(0);
  opacity: 0;
}


.custom-scrollbar::-webkit-scrollbar { width: 4px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #33b35a; border-radius: 10px; }
.fa-chevron-down { transition: transform 0.2s ease; }
</style>